import React, {Component} from 'react';
import Tooltip from '@homeaway/react-tooltip';
import Modal from '@homeaway/react-modal';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import GuestFields from '../GuestFields/GuestFields';
import './Base.less';

/**
 * Base
 */
class Base extends Component {
    static defaultProps = {
        onChange: () => {},
        showClearButton: true
    }

    renderModalTitle = () => {
        const {clearButtonLabel, onClear, modalTitle, showClearButton} = this.props;
        return (
            <span>
                <span className="guest-picker__title">{modalTitle}</span>
                {showClearButton &&
                    (<a className="guest-picker__clear-link" onClick={onClear}>
                        {clearButtonLabel}
                    </a>)
                }
            </span>
        );
    }

    renderPrefixElement = () => {
        const {formPrefixElement} = this.props;
        const Element = formPrefixElement;

        return formPrefixElement ? <Element /> : null;
    }

    renderSuffixElement = () => {
        const {formSuffixElement} = this.props;
        const Element = formSuffixElement;

        return formSuffixElement ? <Element /> : null;
    }

    renderGuestFields = () => {
        const {
            adultsCount,
            adultsLabel,
            applyButtonLabel,
            bedroomsCount,
            bedroomsLabel,
            childrenCount,
            childrenLabel,
            clearButtonLabel,
            compRefFun,
            continueButtonLabel,
            disableButton,
            isMobile,
            onApply,
            onChange,
            onClear,
            petIncluded,
            showBedroomsOption,
            showClearButton,
            showContinue,
            showPetOption,
            formPrefixElement,
            formSuffixElement
        } = this.props;

        const formPrefix = typeof formPrefixElement === 'function' ? this.renderPrefixElement() : formPrefixElement;
        const formSuffix = typeof formSuffixElement === 'function' ? this.renderSuffixElement() : formSuffixElement;

        return (
            <div ref={compRefFun}>
                {formPrefix &&
                    <div className="guest-picker__prefix">
                        {formPrefix}
                    </div>
                }

                <GuestFields
                    {...this.props}
                    adultsLabel={adultsLabel}
                    adultsCount={adultsCount}
                    bedroomsLabel={bedroomsLabel}
                    bedroomsCount={bedroomsCount}
                    childrenLabel={childrenLabel}
                    childrenCount={childrenCount}
                    petIncluded={petIncluded}
                    showBedroomsOption={showBedroomsOption}
                    showPetOption={showPetOption}
                    onChange={onChange}
                />

                {formSuffix &&
                    <div className="guest-picker__suffix">
                        {formSuffix}
                    </div>
                }

                {!isMobile &&
                    <div className="row popover-actions">
                        <div className="text-right">
                            {showClearButton &&
                                (<ButtonLink label={clearButtonLabel} size="sm" onClick={onClear}/>)
                            }

                            <ButtonPrimary label={applyButtonLabel} size="sm" onClick={onApply} disabled={disableButton}/>
                        </div>
                    </div>
                }

                {showContinue && isMobile &&
                    <a className="btn btn-primary btn-rounded guest-picker__continue" onClick={onApply} disabled={disableButton}>
                        {continueButtonLabel}
                    </a>
                }
            </div>
        );
    }

    render() {
        const {
            centered,
            className,
            inputs,
            isMobile,
            isOpen,
            onModalClose,
            onClose,
            placement,
            fadeOutDuration
        } = this.props;

        // Mobile (component in modal)
        if (isMobile) {
            return (
                <div className={className}>
                    {inputs}
                    <Modal
                        id="picker-modal"
                        className="guest-picker__modal"
                        title={this.renderModalTitle()}
                        isOpen={isOpen}
                        onClose={onModalClose}
                        isWorkflow
                    >
                        {this.renderGuestFields()}
                    </Modal>
                </div>
            );
        }

        // Desktop (component in popover)
        return (
            <div className={className}>
                <Tooltip
                    fadeOutDuration={fadeOutDuration}
                    tooltipType="popover"
                    trigger="none"
                    wrappingMethod="block"
                    placement={placement}
                    isOpen={isOpen}
                    onClose={onClose}
                    portalClassName="guest-picker__popover"
                    content={this.renderGuestFields()}
                    centered={centered}
                    interactiveContent
                    interactiveContainer
                >
                    {inputs}
                </Tooltip>
            </div>
        );
    }
}

export default Base;
